import { Box, IconButton, Stack, Tooltip, useClipboard, useColorModeValue } from "@chakra-ui/react";
import { BsTelegram, BsTwitter } from "react-icons/bs";
import { MdEmail } from "react-icons/md";

const SocialLinks = () => {
	const { hasCopied, onCopy } = useClipboard('contact@scrollstat.xyz')

	return (
		<Stack direction="row" spacing={4} justify="center">
			<Box as="a" href="https://x.com/scrollstat" target='black'>
				<IconButton
					aria-label="twitter"
					variant="ghost"
					size="lg"
					icon={<BsTwitter size="28px" />}
					_hover={{
						bg: 'blue.500',
						color: useColorModeValue('white', 'gray.700'),
					}}
					isRound
				/>
			</Box>

			<Box as="a" href="https://t.me/scrollstat" target='black'>
				<IconButton
					aria-label="telegram"
					variant="ghost"
					size="lg"
					icon={<BsTelegram size="28px" />}
					_hover={{
						bg: 'blue.500',
						color: useColorModeValue('white', 'gray.700'),
					}}
					isRound
				/>
			</Box>

			<Tooltip label={hasCopied ? 'Email Copied!' : 'Copy Email'} closeOnClick={false} hasArrow>
				<IconButton
					aria-label="email"
					variant="ghost"
					size="lg"
					fontSize="3xl"
					icon={<MdEmail />}
					_hover={{
						bg: 'blue.500',
						color: useColorModeValue('white', 'gray.700'),
					}}
					onClick={onCopy}
					isRound
				/>
			</Tooltip>
		</Stack>
	)
}

export default SocialLinks;